import { useCallback, useEffect, useState } from 'react'
import { provider } from 'web3-core'

import BigNumber from 'bignumber.js'
import { useWallet } from 'use-wallet'

import { getEarned, getMasterChefContract } from '../cvip/utils'
import useCvip from './useCvip'
import useBlock from './useBlock'

const useEarnings = (pid: number) => {
  const [balance, setBalance] = useState(new BigNumber(0))
  const {
    account,
    ethereum,
  }: { account: string; ethereum: provider } = useWallet()
  const cvip = useCvip()
  const masterChefContract = getMasterChefContract(cvip)
  const block = useBlock()

  const fetchBalance = useCallback(async () => {
    const balance = await getEarned(masterChefContract, pid, account)
    setBalance(new BigNumber(balance))
  }, [account, masterChefContract, cvip])

  useEffect(() => {
    if (account && masterChefContract && cvip) {
      fetchBalance()
    }
  }, [account, block, masterChefContract, setBalance, cvip])

  return balance
}

export default useEarnings
